<template>
  <div class="box white  mb-3">
    <K2Row space-between="true" class="p-3">

      <K2Text bold="true" class-name="" :style="{fontSize:uiVariable.fontSize.lg}">{{ lang("Publish") }}</K2Text>
      <K2Row>
        <div v-b-toggle="'publish'">
          <K2Icon color="black" name="expand_less" class="when-open"/>
          <K2Icon color="black" name="expand_more" class="when-closed"/>
        </div>
      </K2Row>
    </K2Row>
    <b-collapse id="publish" visible>
      <div>
        <form class="needs-validation form-style vs-con-loading__container" novalidate
              @submit.prevent="onSubmit"
              id="div-with-loading">
          <div class="px-3 pb-3">

            <K2Row space-between="true" class="mb-3 flex-wrap">
              <K2Button size="small" class="me-2 mb-2" @onclick="setStatus('Draft')" theme="2">
                {{ lang("Save Draft") }}
              </K2Button>
              <K2Button size="small" class="me-2 mb-2" theme="2" @onclick="handlePreview('preview')">
                {{ lang("Preview") }}
              </K2Button>
              <K2Confirm
                  :title="lang('Are you sure you want to discard the content and back to activity page?')"
                  theme="2" @confirm="backLanding()" no-children="true"
                  :label="lang('Cancel')"/>
            </K2Row>
            <div class="mb-4">
              <K2Row space-between="true" align="center" class="mb-2">
                <K2Row align="center" justify_content="flex-start">
                  <K2Icon name="date_range" class="me-1"/>
                  <K2Text v-if="postDate">{{ lang("Schedule post") }} {{
                      moment(postDate).format("YYYY-MM-DD")
                    }}
                  </K2Text>
                  <K2Text v-else-if="this.parentPost">{{ lang("Publish on") }}
                    {{ parentPost.PostCreatedDate_convert }}
                  </K2Text>
                  <K2Text v-else>{{ lang("Publish Now") }}</K2Text>
                </K2Row>
                <K2Text link="true" @onclick="handleSchedule">{{ lang("Edit") }}</K2Text>
              </K2Row>
              <K2Row class="postSchedule " v-if="schedule">
                <el-date-picker
                    v-model="postDate"
                    type="date"
                    :picker-options="pickerBeginDateAfter"
                    :minDate="moment().format('YYYY-MM-DD')"
                    :placeholder="lang('Pick a date')"
                    :default-value="moment().format('YYYY-MM-DD')">
                </el-date-picker>
                <K2Button size="mini" class-name="p-1" theme="2"
                          :styles="{height:'100%', color:'white'}"
                          :background="uiVariable.color.link" @onclick="handleSchedule(false)">
                  <K2Icon name="done" :font-size="uiVariable.fontSize.lg"/>
                </K2Button>
              </K2Row>
            </div>

            <K2Row>
              <el-checkbox v-model="saveAsTemplate" class="text-center me-2"/>
              <K2Text link="true" class="text-left d-block">{{ lang("Save as template") }}</K2Text>
            </K2Row>
          </div>

          <K2Row justify_content="flex-end" class="box purple p-2">
            <K2Button size="small" @onclick="onSubmit" v-if="saveAsTemplate">{{ lang("Save Template") }}
            </K2Button>
            <K2Button size="small" @onclick="onSubmit" v-else>{{ lang("Submit Post") }}</K2Button>
          </K2Row>
        </form>
      </div>
    </b-collapse>
    <K2Modal :fullscreen="false" :dialog="modal==='preview'" @handleClose="handleClose" @onConfirm="handleClose"
             :hideFooter="true" :hideHeader="true">
      <K2Row justify_content="center" class="position-relative pb-3" align="center" space-between="true">
        <K2Icon color="black" name="chevron_left" @onclick="handleClose" link="true"
                style="top:0"/>
        <K2Heading type="h5" class-name="mb-0" color="black">{{ lang("Preview Post") }}</K2Heading>
        <K2Button size="small" @onclick="handlePreviewSubmit">{{ lang("Submit Post") }}</K2Button>
      </K2Row>
      <ActivityPreview :passtaparent="passtaparent" :posttitle="posttitle" :passselectedfile="passselectedfile"
                       :postType="postType" v-if="modal === 'preview'"
                       :passmselectedstudents="passmselectedstudents" :passkeytags="passkeytags"
                       :passdevelopmentgoals="passdevelopmentgoals" :passSelectedLevel="passSelectedLevel"
                       :passmisselectedalllevels="passmisselectedalllevels" :passmisallclasses="passmisallclasses"
                       :passmseelctedclasses="passmseelctedclasses" :passmselectedlevels="passmselectedlevels"/>
    </K2Modal>
  </div>
</template>

<script>
import K2Heading from "../../../uiComponents/k2Heading/k2Heading";
import K2Icon from "../../../uiComponents/k2Icon/k2MAIcon";
import K2Row from "../../../uiComponents/k2Row/k2Row";
import uiVariable from "../../../config/uiVariable";
import DataSource from "../../../data/datasource";
import K2Button from "../../../uiComponents/k2Button/k2Button";
import K2Text from "../../../uiComponents/k2Text/k2Text";
import { lang } from "../../../locale/index";
import K2Confirm from "../../../uiComponents/k2Confirm/k2Confirm";
import K2ToolTip from "../../../uiComponents/k2ToolTip/k2ToolTip";
import K2Modal from "../../../uiComponents/k2Modal/k2Modal";
import ActivityPreview from "./activityPreview";
import moment from "moment";
import { sleep } from "@/helper/utily";

export default {
  name: "activityPublish",
  components: { ActivityPreview, K2Modal, K2ToolTip, K2Confirm, K2Text, K2Button, K2Row, K2Icon, K2Heading },
  props: ["posttitle", "passtaparent", "passselectedfile", "passmselectedstudents", "passkeytags", "passdevelopmentgoals", "passmisselectedalllevels",
    "passSelectedLevel", "passmisallclasses", "passmseelctedclasses", "passmselectedlevels", "handleLoad", "postType", "isUpdate", "parentPost", "userRole"],
  watch: {
    parentPost: function(value, oldval) {
      if (value) {
        this.PostID = value.PostID || value.POSTID;
      }
    }
  },
  data() {
    return {
      uiVariable: uiVariable,
      moment: moment,
      tagClassID: "",
      tagLevelID: "",
      isAllowComment: false,
      postStatus: "Approved",
      results: "",
      porDevelopmentObject: [],
      selectedFile: [],
      tags: [],
      isAllLevel: "",
      isAllClasses: "",
      saveAsTemplate: false,
      modal: null,
      PostID: null,
      postDate: null,
      schedule: false,
      isUnmount: false,
      shouldRolling: true,
      pickerBeginDateAfter: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      }
    };
  },
  mounted() {
    this.init();
    const self = this;
  },
  beforeDestroy() {
    this.isUnmount = true;
  },
  methods: {
    lang,
    init() {
      this.$emit("tacontent", this.content);
      this.autoSave();
    },
    async autoSave() {
      if (!this.isUnmount && !this.isUpdate && this.parentPost?.POSTSTATUS !== "Template") {
        if (this.posttitle) {
          let tempPostID;
          if(this.PostID){
            tempPostID = this.PostID;
          }
          // this.postType = this.parentPost?.POSTSTATUS
          // if (this.parentPost?.POSTSTATUS === "Template") {
          //     this.saveAsTemplate = true;
          // }
          this.postStatus = this.parentPost?.POSTSTATUS ? this.parentPost?.POSTSTATUS : "Draft";
          await this.onSubmit(this.parentPost?.POSTSTATUS ? this.parentPost?.POSTSTATUS : "Draft", tempPostID, true);
        }
        // await sleep(15000);
        await sleep(300000);
        if (this.shouldRolling) {
          return this.autoSave();
        }
      }
    },
    showLoading() {
      this.$vs.loading();
    },
    hideLoading() {
      this.$vs.loading.close();
    },
    backLanding() {
      this.$router.push("/Activity");
    },
    handleSchedule(status) {
      if (status) {
        this.schedule = status;
      } else {
        this.schedule = !this.schedule;
      }
    },
    async onSubmit(val, tempPostID, isAutosave) {
      if (this.passmisselectedalllevels || this.postType === "Broadcasts") {
        this.isAllLevel = 1;
      } else {
        this.isAllLevel = null;
      }

      if (!this.posttitle) {
        this.$notify({
          title: lang("Error"),
          message: lang("Please Insert Post Title"),
          type: "error"
        });
      } else if (!this.passtaparent && val !== "Draft" && !this.saveAsTemplate ) {
        this.$notify({
          title: lang("Error"),
          message: lang("Please Insert Post Content"),
          type: "error"
        });
      } else if (!this.postType) {
        this.$notify({
          title: lang("Error"),
          message: lang("Please Select Post Type"),
          type: "error"
        });
      } else if ((this.passmselectedstudents && this.passmselectedstudents.length < 1) && (this.passmselectedlevels && this.passmselectedlevels.length < 1) && (this.passmseelctedclasses && this.passmseelctedclasses.length < 1) && this.postStatus !== "Draft") {
        if (!this.isAllLevel) {
          this.$notify({
            title: lang("Error"),
            message: lang("Please select a student ..."),
            type: "error"
          });
        }
      } else {
        await this.submitPost(val, tempPostID, isAutosave);
      }
    },
    async checkIsVideo() {
      const isVideo = this.passselectedfile.find(d => d.type === "video/mp4");
      if (isVideo) {
        return true;
      } else {
        return null;
      }
    },
    handleSubmitFile(isVideo) {
      let newFileList = [];
      this.passselectedfile.forEach(d => {
        newFileList.push(d.file);
      });
      this.selectedFile = newFileList;
      return this.postStatus;
      // if (isVideo) {
      //   this.selectedFile = null;
      //   return "Draft";
      // } else {
      //   this.selectedFile = this.passselectedfile;
      //   let arrobj_AcceptedFiles = [];
      //
      //   this.selectedFile.forEach(file => {
      //     if (file.oriType === "heic") {
      //       file = new File([file], file.name, {
      //         type: file.type,
      //         lastModified: new Date()
      //       });
      //       arrobj_AcceptedFiles.push(file);
      //
      //     } else {
      //       arrobj_AcceptedFiles.push(file);
      //
      //     }
      //   });
      //   this.selectedFile = arrobj_AcceptedFiles;
      //   return this.postStatus;
      // }
    },
    async submitPost(type, tempPostID, isAutosave) {
      if (!isAutosave) {
        this.showLoading();
      }
      const isVideo = await this.checkIsVideo();
      let isDraft = type === "Draft";
      let studentIDList = [];
      let levelIDList = [];
      let classIDList = [];
      let scheduleDate, scheduleStatus, newPostStatus;
      if (this.passmselectedstudents && this.passmselectedstudents.length) {
        this.passmselectedstudents.forEach(d => {
          d.itemList.forEach(m => {
            studentIDList.push(m.Student_ID || m.PostTagUserID);
          });
        });
      }
      if (this.passmselectedlevels && this.passmselectedlevels.length) {
        this.passmselectedlevels.forEach(d => {
          levelIDList.push(d.Str_ID || d.PostTagLevelID);
        });
      }
      if (this.passmseelctedclasses && this.passmseelctedclasses.length) {
        this.passmseelctedclasses.forEach(d => {
          classIDList.push(d.Str_ID || d.PostTagClassID);
        });
      }

      if (levelIDList && levelIDList.length > 0) {
        this.tagLevelID = levelIDList;
      } else if (classIDList && classIDList.length > 0) {
        this.tagClassID = classIDList;
      } else {
        this.tags = studentIDList;
      }
      this.isAllClasses = this.passmisallclasses;
      if (this.passkeytags && this.passkeytags.length < 0) {
        this.passkeytags = "";
      }
      if (this.passdevelopmentgoals && this.passdevelopmentgoals.length < 0) {
        this.passdevelopmentgoals = "";
      }
      if (!isDraft) {
        if (this.saveAsTemplate) {
          this.postStatus = "Template";
        } else {
          this.postStatus = "Approved";
        }
      } else {
        this.postStatus = "Draft";
      }
      newPostStatus = await this.handleSubmitFile(isVideo);

      if (this.postDate) {
        scheduleDate = moment(this.postDate).format("Y-MM-DD");
        this.postStatus = "Scheduled";
        scheduleStatus = "Scheduled";
      }

      if (this.postType === "Broadcast") {
        this.postType = "Broadcast";
        this.isAllLevel = 1;
        this.tagLevelID = null;
      }
      try {
        let allowComment = "";
        if (this.isAllowComment) {
          allowComment = "Yes";
        } else {
          allowComment = "No";
        }

        const saveResponse = await DataSource.shared.savePostUpdateJapan(this.selectedFile,this.passtaparent,
            this.tags, this.tagClassID, this.tagLevelID, this.PostID && this.PostID, allowComment,
            JSON.stringify(this.passdevelopmentgoals), JSON.stringify(this.passkeytags),
            newPostStatus, this.isAllLevel, this.isAllClasses, this.posttitle, this.postType, scheduleDate, scheduleStatus);

        if (saveResponse) {
          // if (saveResponse.code == "1"){
          //   this.$emit("result", "TRUE");
          //   this.hideLoading()
          // }else{
          //   this.$emit("result", "FALSE");
          switch (saveResponse.code) {
            case "1":
              if (isVideo) {
                if (this.postStatus !== "Approved") {
                  this.$notify({
                    title: lang("Success"),
                    message: `${lang("Video Uploading")}, ${this.postStatus} ${lang("will be active in a while")}`,
                    type: "success"
                  });
                } else {
                  this.$notify({
                    title: lang("Success"),
                    message: `${lang("Video Uploading")}, ${lang("activity")} ${lang("will be active in a while")}`,
                    type: "success"
                  });
                }
                await this.handleVideoSubmit(saveResponse, allowComment);
              } else if (this.isUpdate) {
                this.$notify({
                  title: lang("Success"),
                  message: lang("Post Updated"),
                  type: "success"
                });
              }else if (isAutosave) {
                this.$notify({
                  title: lang("Success"),
                  message: lang("Autosaved in draft"),
                  type: "success"
                });
              } else if (isDraft) {
                this.$notify({
                  title: lang("Success"),
                  message: lang("Draft Saved"),
                  type: "success"
                });
              } else {
                this.$notify({
                  title: lang("Success"),
                  message: lang("Post Submitted, activity will be active in a while"),
                  type: "success"
                });
              }

              this.selectedFile = [];
              this.tagLevelID = null;
              this.tagClassID = null;
              this.results = `Post Submitted`;
              if (this.parentPost?.POSTSTATUS !== "Template") {
                await DataSource.shared.softDeletePost(tempPostID ? tempPostID : this.PostID);
              }
              if (!isAutosave) {
                await this.$router.push("/Activity");
                this.hideLoading();
              }else{
                this.PostID = saveResponse?.PostID;
              }
              // this.$vs.loading.close();
              break;
            case "88":
              this.$vs.loading.close();
              this.$notify.error({
                title: lang("Error"),
                message: lang("Please Login to submit post")
              });
              this.systemmsgError = true;
              break;
            case "99":
              this.$vs.loading.close();
              this.$notify.error({
                title: lang("Error"),
                message: lang("System Error")
              });
              this.systemmsgError = true;
              break;
              // default:
              //     alert("Please try again later");
              //     this.results = JSON.stringify(response);
          }//switch

          // }

        }//saveresponse endif
      }//try
      catch (e) {
        console.log(e, "submit post err");
        this.error = e;
      }
    },
    async handleVideoSubmit(saveResponse, allowComment) {
      await DataSource.shared.softDeletePost(this.PostID);
      // this.$router.push({name: 'NewActivityPage', params: {post: this.previewPost}});
      await this.$router.push({
        name: "ActivityPage", params: {
          selectedFile: this.passselectedfile,
          passtaparent: this.passtaparent,
          tags: this.tags,
          tagClassID: this.tagClassID,
          tagLevelID: this.tagLevelID,
          PostID: saveResponse.PostID,
          allowComment: allowComment,
          passdevelopmentgoals: JSON.stringify(this.passdevelopmentgoals),
          passkeytags: JSON.stringify(this.passkeytags),
          postStatus: this.postStatus,
          isAllLevel: this.isAllLevel,
          isAllClasses: this.isAllClasses,
          posttitle: this.posttitle,
          postType: this.postType
        }
      });
      this.hideLoading();

    },
    setStatus(val) {
      this.postStatus = val;
      this.onSubmit(val);
    },
    handlePreview(type) {
      this.modal = type;
    },

    handleClose() {
      this.modal = null;
    },
    handlePreviewSubmit() {
      this.handleClose();
      this.onSubmit();
    }
  }//methods

};
</script>